import * as React from 'react';

import sortIcon from '../../images/icons/sort.svg';
import sortUpIcon from '../../images/icons/sort-up.svg';
import sortDownIcon from '../../images/icons/sort-down.svg';

export interface SortState {
    column: string | null;
    descending: boolean;
}

// none -> ascending -> descending -> none
export const nextSortState = (
    current: SortState | null | undefined,
    columnKey: string
): SortState => {
    if (!current || current.column !== columnKey) {
        return { column: columnKey, descending: false };
    }
    if (!current.descending) {
        return { column: columnKey, descending: true };
    }
    return { column: null, descending: false };
};

interface SortableColumnHeaderProps {
    label: string;
    columnKey: string;
    sort: SortState | null | undefined;
    onSort: (columnKey: string) => void;
}

export const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
    label,
    columnKey,
    sort,
    onSort
}) => {
    const isActive = !!sort && sort.column === columnKey;
    const icon = !isActive
        ? sortIcon
        : sort!.descending
        ? sortDownIcon
        : sortUpIcon;

    const handleSort = () => onSort(columnKey);

    return (
        <span
            className={`sortable-column-header${isActive ? ' is-active' : ''}`}
            role="button"
            tabIndex={0}
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                handleSort();
            }}
            onKeyDown={(e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSort();
                }
            }}
        >
            <span className="sortable-column-header__label">{label}</span>
            <img
                className="sortable-column-header__icon"
                src={icon}
                alt=""
                aria-hidden={true}
            />
        </span>
    );
};
